<template>
<a-col style="padding-left:5px;padding-right:5px;padding-top:8px;">
  <a-card hoverable bordered  style="width: 100%">
    <template v-slot:cover>
    <img :src="showCover ? item.pic : item.part" />
    </template>
    <template v-slot:actions class="ant-card-actions">
      <span style="color:blue">{{item.item_code}}</span>
      <span style="color:red">${{item.price}} / {{item.unit}}</span>
    </template>
     <a-card-meta>
       <template v-slot:title>
         <h6>{{item.item_name}}</h6>
      </template>
      <template v-slot:description>
        <div style="max-width:350px;word-wrap:break-word;text-align:left;">
          {{item.description}}
          <p>
          <a @click="switchShow()" style="color:blue;text-decoration:underline;"><eyeTwoTone /> {{showWhat}}</a>
          </p>
        </div>
      </template>
    </a-card-meta>
  </a-card>
</a-col>
</template>
<script>
  import { onMounted, onBeforeMount, ref } from 'vue'
  export default {
    name: 'WagyuItem',
    props: {
        item: Object
    },
    setup() {
        var showCover = ref(true)
        var showWhat  = ref('Show me the part')
        const switchShow = () => {
            showCover.value = showCover.value ? false : true
            if(showCover.value == true)
              showWhat.value = 'Show me the part'
            else
              showWhat.value = 'Show me the meat'
            
            console.log(showCover.value)
        }
        onMounted(() => {
            console.log("Wagyu Item mounted!")
        })
        onBeforeMount(() => {
            console.log("before mount executed!" )
        })

        return { showCover, showWhat, switchShow }
    }
  };
</script>
<style lang="scss" scoped>
</style>